// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__26adW","imageUploader":"EGiftCard_imageUploader__2hbJ_"};